import { PropsWithChildren, useState } from "react";
import { PlacementType } from "../../constants/placement";
import {
  ToolTipPopUpWrapper,
  ToolTipArrow,
  ToolTipContent,
  ToolTipWrapper,
} from "./atom";
import { CSSProperties } from "styled-components";
export function ToolTip({
  placement = "top",
  mode = "dark",
  content = "",
  offsetX = "0px",
  offsetY = "0px",
  active = false,
  trigger = "hover",
  hidden = false,
  children,
  style,
  color,
  maxWidth,
  onBlur = () => {},
  onClick = () => {},
  ...props
}: ToolTipProps) {
  const [show, setShow] = useState(active);
  const handleHover = () => {
    if (trigger === "click") return;
    setShow(true);
  };
  const handleBlur = () => {
    onBlur();
    if (active) return;
    setShow(false);
  };
  const handleClick = () => {
    setShow(true);
    onClick();
  };
  return (
    <ToolTipWrapper
      onMouseOver={handleHover}
      onMouseOut={handleBlur}
      onClick={handleClick}
      style={style}
      className="tooltip-wrapper"
      {...props}
    >
      {children}
      {show && !hidden && (
        <ToolTipPopUpWrapper
          placement={placement}
          mode={mode}
          offsetX={offsetX}
          offsetY={offsetY}
          maxWidth={maxWidth}
          className="tooltip-popup-wrapper"
        >
          <ToolTipContent color={color} className="tooltip-content">
            {content}
          </ToolTipContent>
          <ToolTipArrow />
        </ToolTipPopUpWrapper>
      )}
    </ToolTipWrapper>
  );
}
export type ToolTipTriggerType = "hover" | "click";
export type ToolTipModeType = "dark" | "light";
export type ToolTipProps = PropsWithChildren<{
  placement?: PlacementType;
  mode?: ToolTipModeType;
  content: string | number | React.ReactNode;
  offsetX?: string;
  offsetY?: string;
  active?: boolean;
  trigger?: ToolTipTriggerType;
  hidden?: boolean;
  style?: CSSProperties;
  color?: string;
  maxWidth?: string;
  onBlur?: () => void;
  onClick?: () => void;
}>;
